// Send to memory…'s sheet (brief 49): which organisation, when the desktop app is signed in to
// several as a Manager or an Admin; then what goes before it is sent; then the new source, with
// Open in Memories.

import { sendWords, sentWords, type Imported, type Organisation } from '../core/memory.ts'

export type MemoryState =
  | { stage: 'choose'; organisations: Organisation[] }
  | { stage: 'confirm'; organisation: Organisation; name: string; xml: string; paired: number; oneSided: number; excluded: number }
  | { stage: 'sending'; organisation: Organisation; name: string }
  | { stage: 'done'; organisation: Organisation; name: string; imported: Imported; source: string }

interface Props {
  state: MemoryState
  onClose: () => void
  onChoose: (organisation: Organisation) => void
  onSend: () => void
  onOpen: () => void
}

export function MemorySheet({ state, onClose, onChoose, onSend, onOpen }: Props) {
  const box = (label: string, body: React.ReactNode) => (
    <div className="dialog" data-memory={state.stage}>
      <div className="dbox review" role="dialog" aria-label={label}>
        <h2>{label}</h2>
        {body}
      </div>
    </div>
  )
  switch (state.stage) {
    case 'choose':
      return box('Which organisation?', <>
        <p>This app is signed in to several organisations as a Manager or an Admin. The TMX goes into the memory of the one you pick.</p>
        <ul className="choices">
          {state.organisations.map(o => (
            <li key={o.origin}><button data-memory-organisation={o.origin} onClick={() => onChoose(o)}>{o.name}</button></li>
          ))}
        </ul>
        <div className="dactions"><button onClick={onClose}>Cancel</button></div>
      </>)
    case 'confirm': {
      const words = sendWords(state.organisation, state.name, state.paired, state.oneSided, state.excluded)
      return box('Send to memory', <>
        <p data-memory-line="to">{words.to}</p>
        <p data-memory-line="counts">{words.counts}</p>
        <div className="dactions">
          <button onClick={onClose} data-memory-action="cancel">Cancel</button>
          <button className="primary" autoFocus onClick={onSend} data-memory-action="send" disabled={state.paired === 0}>Send</button>
        </div>
      </>)
    }
    case 'sending':
      return box('Send to memory', <p role="status">Sending to {state.organisation.name}’s memory…</p>)
    case 'done':
      return box('Sent to memory', <>
        <p data-memory-line="sent">{sentWords(state.organisation, state.name, state.imported)}</p>
        <div className="dactions">
          <button onClick={onOpen} data-memory-action="open">Open in Memories</button>
          <button className="primary" autoFocus onClick={onClose}>OK</button>
        </div>
      </>)
  }
}
